import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useModalData } from '../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useDynamicServiceOrderState = () => React.useContext(Context)
export const useDynamicServiceOrder = () => useDynamicServiceOrderState()?.dynamicServiceOrder

const QUERY = gql`
  query DynamicServiceOrder($id: ID) {
    dynamicServiceOrder(id: $id) {
      id
      name
      description
      redirectToExecution
      shareCode
      themeColor
      configuration
      place {
        id
        name
      }
      logo {
        id
        src
      }
      checklist {
        id
        name
      }
    }
  }
`

const DynamicServiceOrderLoader = ({ children }) => {
  const { id } = useModalData() || {}
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default DynamicServiceOrderLoader
